import { useIsLoggedIn } from '@dreamstack/auth'
import { useTranslation } from '@dreamstack/i18n'
import { useMemo } from 'react'
import * as yup from 'yup'
import { useYupValidationResolver } from '../index'

export type PropAndProjectContactFormData = {
  clientEmail: string
  clientFirstName: string
  clientLastName: string
  clientPhone: string
  clientSalutation: string
  text: string
  consent: boolean
  subscribeNewsletter: boolean
  requestPhone: boolean
}

export const usePropAndProjectContactFormYupObject = () => {
  const t = useTranslation()
  const loggedIn = useIsLoggedIn()
  const schema = useMemo(() => {
    //required yup fields for both loggedIn and not loggedIn Users
    const commonSchema = {
      requestPhone: yup.boolean(),
      clientPhone: yup.string().when('requestPhone', {
        is: true,
        then: yup.string().required(t('accentro:requiredField')),
      }),
      text: yup.string().required(t('accentro:requiredField')),
      consent: yup
        .boolean()
        .oneOf([true], t('accentro:generalForm.requiredConsentMessage')),
      subscribeNewsletter: yup.boolean(),
    }
    if (!loggedIn) {
      //additionally required yup fields for not loggedIn Users
      const fullSchema = {
        ...commonSchema,
        clientEmail: yup
          .string()
          .email(t('accentro:pleaseEnterAValidEmail'))
          .required(t('accentro:pleaseEnterAValidEmail')),
        clientFirstName: yup.string().required(t('accentro:requiredField')),
        clientLastName: yup.string().required(t('accentro:requiredField')),
      }
      return fullSchema
    }
    return commonSchema
  }, [loggedIn, t])
  return schema
}

export const usePropAndProjectContactFormSchema = () => {
  const schema = usePropAndProjectContactFormYupObject()
  return useYupValidationResolver(yup.object(schema))
}
